import { render, staticRenderFns } from "./EscalationEndEvent.vue?vue&type=template&id=3bb0fbb2&scoped=true&"
import script from "./EscalationEndEvent.vue?vue&type=script&lang=js&"
export * from "./EscalationEndEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0fbb2",
  null
  
)

export default component.exports